import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1f07bca2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container long-container wow animate__animated animate__fadeInLeft",
  "data-wow-duration": "2s",
  "data-wow-delay": "0.1s"
};
var _hoisted_2 = {
  class: "row"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-6 imgArea"
  }, null, -1);
});

var _hoisted_4 = {
  class: "col-lg-6 textArea"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, "发展历程", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "研发/生产团队扩增到16人,其中有日本2项个人专利，十数年日本汽车制造/技术经验的管理人员，先后获得29项专利的高级机械设计工程师，取得过8项专利的软件工程师，生物实验行业翘楚（Tecan，Hamilton等） ", -1);
});

var _hoisted_7 = /*#__PURE__*/_createTextVNode("了解更多");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createVNode(_component_router_link, {
    class: "more",
    to: "/history"
  }, {
    default: _withCtx(function () {
      return [_hoisted_7];
    }),
    _: 1
  })])])]);
}